/**
 * Simple data table with header row and body rows (strings only for demo tooling).
 *
 * @param options - Column titles and row values (same length as headers per row).
 * @returns **`HTMLTableElement`** with **`qz-table`** class.
 */
export function createTable(
  options: Readonly<{
    headers: ReadonlyArray<string>;
    rows: ReadonlyArray<ReadonlyArray<string>>;
  }>,
): HTMLTableElement {
  const table = document.createElement("table");
  table.className = "qz-table";

  const thead = document.createElement("thead");
  const hr = document.createElement("tr");
  for (const h of options.headers) {
    const th = document.createElement("th");
    th.textContent = h;
    hr.appendChild(th);
  }
  thead.appendChild(hr);
  table.appendChild(thead);

  const tbody = document.createElement("tbody");
  for (const row of options.rows) {
    const tr = document.createElement("tr");
    for (const cell of row) {
      const td = document.createElement("td");
      td.textContent = cell;
      tr.appendChild(td);
    }
    tbody.appendChild(tr);
  }
  table.appendChild(tbody);

  return table;
}
